import { Dropdown } from "@/components/common/Dropdown";
import { IconButton } from "@/components/common/IconButton";
import { ComponentType } from "@/interfaces/common";
import clsx from "clsx";

export interface TableActionsMenuProps {
  children: ComponentType<typeof IconButton> | ComponentType<typeof IconButton>[];
  className?: string;
}

export const TableActionsMenu = ({ children, className }: TableActionsMenuProps) => {
  /**
   * Aceita item único porque menus podem começar com uma ação e crescer depois.
   */
  const items = Array.isArray(children) ? children : [children];

  return (
    <Dropdown
      icon="MoreVertical"
      rotateToggler={false}
      className={clsx("flex w-fit items-center gap-2 border border-background-secondary p-1", className)}
      aria-label="Abrir menu de ações"
    >
      <ul className="flex max-h-80 flex-col gap-2 overflow-y-auto rounded-md bg-background-primary p-4 shadow-lg min-w-36">
        {items.map((child, index) => (
          <li
            key={index}
            className="[&>*:hover_*:not(.icon)]:!text-primary *:border-none [&_.icon]:!opacity-100 *:p-2 hover:bg-primary-hover rounded-sm *:w-full transition-colors duration-300 empty:hidden"
          >
            {child}
          </li>
        ))}
      </ul>
    </Dropdown>
  );
};
